import type { ComponentType } from "react";
import {
  SiGoogledisplayandvideo360,
  SiMeta,
  SiSnapchat,
  SiTiktok,
  SiYoutube,
} from "@icons-pack/react-simple-icons";
import { Megaphone } from "lucide-react";
import type { PreflightPlatformCode } from "@nexus/contracts";

/** The prop surface both `simple-icons` and `lucide-react` glyphs satisfy. */
type PlatformGlyphProps = {
  className?: string;
  focusable?: boolean;
  "aria-hidden"?: boolean;
  /**
   * `simple-icons` glyphs render `<title>{brand}</title>` unless told otherwise, which
   * would repeat the adjacent label in the DOM. Callers pass an empty string to drop it.
   */
  title?: string;
};

export interface PlatformBrandIcon {
  Glyph: ComponentType<PlatformGlyphProps>;
  /**
   * Brand colours are external constants with no semantic token, so they are arbitrary
   * Tailwind values — the same treatment as the Google sign-in button in `LoginForm`.
   *
   * TikTok and Snapchat carry a dark-mode variant because their official black and
   * yellow each vanish against one of the two themes.
   */
  colorClassName: string;
}

export const PLATFORM_BRAND_ICONS: Record<
  PreflightPlatformCode,
  PlatformBrandIcon
> = {
  META: { Glyph: SiMeta, colorClassName: "text-[#0467DF]" },
  YOUTUBE: { Glyph: SiYoutube, colorClassName: "text-[#FF0000]" },
  SNAPCHAT: {
    Glyph: SiSnapchat,
    colorClassName: "text-[#B8A400] dark:text-[#FFFC00]",
  },
  TIKTOK: { Glyph: SiTiktok, colorClassName: "text-[#010101] dark:text-white" },
  DV360: {
    Glyph: SiGoogledisplayandvideo360,
    colorClassName: "text-[#34A853]",
  },
  // Adform ships no mark in simple-icons, so a themed glyph stands in rather than an
  // invented logo and brand colour.
  ADFORM: { Glyph: Megaphone, colorClassName: "text-primary" },
};
